import { default as index8w8T3TYZXUMeta } from "/var/www/pages/[lang]/index.vue?macro=true";
import { default as uaXzHPReJwcNMeta } from "/var/www/pages/[lang]/ua.vue?macro=true";
import { default as indexTNebhwOASsMeta } from "/var/www/pages/index.vue?macro=true";
import { default as healthzUJyHLXiUK6Meta } from "/var/www/pages/manage/healthz.vue?macro=true";
export default [
  {
    name: index8w8T3TYZXUMeta?.name ?? "lang",
    path: index8w8T3TYZXUMeta?.path ?? "/:lang()",
    meta: index8w8T3TYZXUMeta || {},
    alias: index8w8T3TYZXUMeta?.alias || [],
    redirect: index8w8T3TYZXUMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: uaXzHPReJwcNMeta?.name ?? "lang-ua",
    path: uaXzHPReJwcNMeta?.path ?? "/:lang()/ua",
    meta: uaXzHPReJwcNMeta || {},
    alias: uaXzHPReJwcNMeta?.alias || [],
    redirect: uaXzHPReJwcNMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/ua.vue").then(m => m.default || m)
  },
  {
    name: indexTNebhwOASsMeta?.name ?? "index",
    path: indexTNebhwOASsMeta?.path ?? "/",
    meta: indexTNebhwOASsMeta || {},
    alias: indexTNebhwOASsMeta?.alias || [],
    redirect: indexTNebhwOASsMeta?.redirect,
    component: () => import("/var/www/pages/index.vue").then(m => m.default || m)
  },
  {
    name: healthzUJyHLXiUK6Meta?.name ?? "manage-healthz",
    path: healthzUJyHLXiUK6Meta?.path ?? "/manage/healthz",
    meta: healthzUJyHLXiUK6Meta || {},
    alias: healthzUJyHLXiUK6Meta?.alias || [],
    redirect: healthzUJyHLXiUK6Meta?.redirect,
    component: () => import("/var/www/pages/manage/healthz.vue").then(m => m.default || m)
  }
]